import { render, staticRenderFns } from "./DoctorPatientFiles.vue?vue&type=template&id=7ae4f1ab&"
import script from "./DoctorPatientFiles.vue?vue&type=script&lang=js&"
export * from "./DoctorPatientFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports